module.exports = __webpack_public_path__ + "media/images/icon__delete--rb-orange@3x-a55b94bc64d00904c374b9da97f6cacf.png";